import {
  ChannelDataEntry,
  MarketplaceContact,
  ListingEditFormValues,
  MarketplaceData,
  MarketplaceEquipment,
  MarketplaceExtraData,
  MarketplaceLocation,
  MarketplacePayment,
  MarketplaceVehicleSpecs,
} from "./types";
import { CardSelectOption } from "ui/components/CardSelect";

export const MARKETPLACE_CHANNEL_CODE = "marketplace";

// Redoslijed koraka čarobnjaka. Imenovano jer se validacija veže na indeks — s golim
// brojevima umetanje koraka tiho pomakne provjeru cijene na krivi korak.
export const LISTING_WIZARD_STEPS = {
  channelPicker: 0,
  marketplace: 1,
  additionalInfo: 2,
  pictures: 3,
  price: 4,
  preview: 5,
} as const;

export const initialChannelDataEntry: ChannelDataEntry = {
  titleOverride: "",
  priceOverride: "",
  descriptionOverride: "",
};

export const initialMarketplaceVehicleSpecs: MarketplaceVehicleSpecs = {
  manufacturingYear: "",
  manufacturerId: "",
  modelId: "",
  typeName: "",
  fuelTypeCode: "",
  driveTypeCode: "",
  doors: "",
  powerKw: "",
  transmissionCode: "",
  bodyShapeCode: "",
  displacementCm3: "",
  modelYear: "",
  seats: "",
  suspensionCode: "",
  colorId: "",
  metallic: false,
  tireWidth: "",
  tireHeight: "",
  tireDiameter: "",
  kmTraveled: "",
  vehicleConditionCode: "",
};

export const initialMarketplaceExtra: MarketplaceExtraData = {
  fuelConsumption: "",
  co2Emission: "",
  ecoCategoryCode: "",
  hasGas: false,
  garaged: false,
  inTrafficSinceYear: "",
  firstRegistrationYearRH: "",
  registeredUntil: "",
  warrantyCode: "",
  extendedWarranty: false,
  g1ClubWarranty: false,
  ownerCountCode: "",
  serviceBook: false,
  chassisNumber: "",
  videoCallViewing: false,
  internalCode: "",
};

export const initialMarketplaceEquipment: MarketplaceEquipment = {
  selected: {},
  airbagsCode: "",
  airConditioningCode: "",
  carRadioCode: "",
};

export const initialMarketplacePayment: MarketplacePayment = {
  priceIncludesImport: "",
  options: {},
};

export const initialMarketplaceLocation: MarketplaceLocation = {
  countyCode: "",
  municipalityCode: "",
  settlementCode: "",
  manualAddress: "",
  display: "approximate",
};

export const initialMarketplaceContact: MarketplaceContact = {
  contactUserIds: [],
  locationOfficeIds: [],
  contactId: "",
};

export const initialMarketplaceData: MarketplaceData = {
  specs: initialMarketplaceVehicleSpecs,
  extra: initialMarketplaceExtra,
  equipment: initialMarketplaceEquipment,
  payment: initialMarketplacePayment,
  location: initialMarketplaceLocation,
  contact: initialMarketplaceContact,
  youtubeUrl: "",
};

export const initialListingEditForm: ListingEditFormValues = {
  selectedChannelIds: [],
  baseTitle: "",
  basePrice: "",
  baseDescription: "",
  selectedPictureUploadIds: [],
  marketplaceData: initialMarketplaceData,
  channelData: {},
  channels: [],
  vehicle: null,
  pictures: [],
  unmatchedEquipment: [],
  templates: [],
  templateId: "",
};

// Odabir izvora lokacije u koraku Dodatne informacije. Id-jevi odgovaraju `LocationMode`
// u LocationSection-u.
export const LOCATION_MODE_OPTIONS: CardSelectOption[] = [
  {
    id: "office",
    icon: "/media/icons/company.svg",
    title: "Učitaj iz poslovnice",
    description: "Županija, naselje i adresa popune se iz odabrane poslovnice.",
  },
  {
    id: "manual",
    icon: "/media/icons/edit.svg",
    title: "Ručni unos",
    description: "Lokacija se upisuje ručno; oglas nema vezanu poslovnicu.",
  },
];

// Odabir izvora kontakta u koraku Dodatne informacije. Id-jevi odgovaraju `ContactMode`
// u ContactSection-u.
export const CONTACT_MODE_OPTIONS: CardSelectOption[] = [
  {
    id: "settings",
    icon: "/media/icons/setting.svg",
    title: "Kontakt iz postavki",
    description: "Bira se jedan djelatnik iz zadanih postavki oglasa.",
  },
  {
    id: "manual",
    icon: "/media/icons/users.svg",
    title: "Odaberi za ovaj oglas",
    description: "Kontakt se bira iz imenika — osoba ili tvrtka.",
  },
];

// Opcije za "Cijena uključuje troškove uvoza" u koraku Cijena.
export const IMPORT_COST_OPTIONS: CardSelectOption[] = [
  {
    id: "with",
    icon: "/media/icons/check.svg",
    title: "Uključuje sve troškove uvoza/unosa",
    description: "Kupac na objavljenu cijenu ne plaća dodatne troškove uvoza.",
  },
  {
    id: "without",
    icon: "/media/icons/close.svg",
    title: "Bez troškova uvoza/unosa",
    description: "Troškovi uvoza/unosa nisu uključeni u objavljenu cijenu.",
  },
];
